import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';

import { LoggerService } from '@app/core/logging/logger.service';
import { ChunkLoadRecoveryService } from './chunk-load-recovery.service';
import { isChunkLoadError } from './chunk-load-error';

/**
 * Manejador de errores GLOBAL. Es global y no una rama pegada en cada
 * `loadComponent`: las rutas perezosas son decenas y una rama por ruta
 * divergiría a la primera.
 *
 * Su única responsabilidad extra sobre el manejador por omisión de Angular es
 * reconocer un `ChunkLoadError` y delegar la recuperación. Todo lo demás se
 * comporta igual: el error se registra y sigue su curso.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);

  /**
   * La recuperación se resuelve PEREZOSAMENTE: el `ErrorHandler` se construye
   * durante el arranque y depender de `MatDialog`/`TranslocoService` aquí
   * arriba crearía un ciclo de dependencias en el inyector raíz.
   */
  private readonly injector = inject(Injector);

  handleError(error: unknown): void {
    // Primero registrar, SIEMPRE: un manejador global que se come los errores
    // es un agujero de diagnóstico.
    //
    // ⚠️ El alcance real de esto depende del `LoggerService`: hoy escribe en
    // consola fuera de producción y es un NO-OP en `production` y en
    // `staging` (los dos compilan con `production: true`), donde el sumidero de
    // monitoreo sigue siendo un comentario en el servicio. O sea que en esos
    // entornos este manejador registra MENOS que el de Angular, que escribía
    // siempre — es lo que pide CLAUDE.md §Security (sin `console.*` en
    // producción), y se cierra enchufando el sumidero en el logger, no aquí.
    this.logger.error(error);

    if (!isChunkLoadError(error)) return;

    this.injector.get(ChunkLoadRecoveryService).recover();
  }
}
